import useJwt from '@core/auth/jwt/useJwt'
import axios from '@/resources/libs/axios'

const { jwt } = useJwt(axios, {})
export default jwt
